export default "__VITE_ASSET__BTpExfbj__"